import React, { Fragment, Component } from 'react';
import './VerifyEmail.scss';

class VerifyEmail extends Component {
    state = {
        loader: false
    }
    render() {
        const { user } = this.props;
        return (
            <Fragment>
                {user && (
                    !user.emailVerified && (
                        <div className='email-verify'>
                            {this.state.loader && (
                                <div className='blur'>
                                    <div className="lds-ring">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                            )}
                            We have sent you an email for verification
                            <button onClick={this.sendEmail}>Send Again</button>
                        </div>
                    )
                )}
            </Fragment>
        )
    }
    sendEmail = () => {
        this.setState({ loader: true });
        this.props.user.sendEmailVerification()
            .then(_ => this.setState({ loader: false }))
            .catch(() => this.setState({ loader: false }))
    }
}

export default VerifyEmail;